import { HIDE_PROGRESS_LOADING, SHOW_PROGRESS_LOADING } from '../actions/actionTypes';

const initialState = {
    url: null,
    onClose: () => {},
    onNextProcess: (result) => {
        return !!result && result.processing;
    },
    onFailure: (e) => console.error(e),
    interval: 1000,
    params: {},
    isLoading: false,
};

export const progressLoadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_PROGRESS_LOADING:
            return {
                ...state,
                ...{ ...initialState, ...action.config },
                isLoading: true,
            };
        case HIDE_PROGRESS_LOADING:
            return {
                ...state,
                ...initialState,
                isLoading: false,
            };
        default:
            return state;
    }
};
